function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import HeroBanner from './HeroBanner';
import HeroDetail from './HeroDetail';
import classNames from '../utils/classNames';
/**
 * The Hero component is a page level component (requires full width).
 *
 * - [Hero Red Lines](https://atlas.np.tools.playstation.net/design/864ab9c0-7f8e-45d4-a4b7-1dfab063ec96/1?bounds=-0.157,-0.001,0.687,0.466&rev=1&x=549.46&y=809.14)
 * - [Hero IXD](https://atlas.np.tools.playstation.net/design/f7c5cf26-8283-4aad-82d9-19b79f31bafa/2?bounds=-0.114,0.437,1.264,0.859)
 *
 * Collaborating Components
 * - [Media](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Media)
 * - [Button](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Button)
 * - [Link](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Link)
 */

var Hero = /*#__PURE__*/function (_PureComponent) {
  _inherits(Hero, _PureComponent);

  var _super = _createSuper(Hero);

  function Hero() {
    _classCallCheck(this, Hero);

    return _super.apply(this, arguments);
  }

  _createClass(Hero, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          primaryArt = _this$props.primaryArt,
          background = _this$props.background,
          gameLogo = _this$props.gameLogo,
          title = _this$props.title,
          body = _this$props.body,
          cta = _this$props.cta,
          strand = _this$props.strand;
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: classNames('psw-l-anchor', 'psw-fill-x', className)
      }, /*#__PURE__*/React.createElement(HeroBanner, {
        qa: qa,
        primaryArt: primaryArt,
        background: background,
        gameLogo: gameLogo
      }), /*#__PURE__*/React.createElement("div", {
        className: "psw-s-content-break-20"
      }, /*#__PURE__*/React.createElement(HeroDetail, {
        qa: qa,
        title: title,
        body: body,
        cta: cta
      }), strand && /*#__PURE__*/React.createElement("div", {
        "data-qa": "".concat(qa, "#strand")
      }, strand)));
    }
  }]);

  return Hero;
}(PureComponent);

Hero.defaultProps = {
  qa: 'hero',
  className: '',
  title: '',
  body: '',
  strand: null
};
Hero.propTypes = {
  /**
   * The test id to use for QA automation. This value should be unique on any given page.
   */
  qa: PropTypes.string,

  /**
   * Any additional classes to apply to the root of the component. This is useful for adding
   * margin to the component.
   */
  className: PropTypes.string,

  /**
   * Generally the hero character art, should be a Image or ideally Media component from web-common
   */
  primaryArt: PropTypes.element.isRequired,

  /**
   * The banner background should be a Image or ideally Media component from web-common
   */
  background: PropTypes.element.isRequired,

  /**
   * The logo art should be a Image or ideally Media component from web-common
   */
  gameLogo: PropTypes.element.isRequired,

  /**
   * Optional title to display in the details below the banner
   */
  title: PropTypes.node,

  /**
   * Optional body / description to display in the details below the banner
   */
  body: PropTypes.node,

  /**
   * Call to action to display in the details below the banner, can be Button or
   * Link from web-common
   */
  cta: PropTypes.element.isRequired,

  /**
   * Strand UI to render
   */
  strand: PropTypes.node
};
export default Hero;